// extracted by mini-css-extract-plugin
export default {"image_upload":"Imageuploader_image_upload__9n1BM","pic_icon":"Imageuploader_pic_icon__ZcG5e"};